export const FETCH_PROMO_CODES_START = 'FETCH_PROMO_CODES_START';
export const FETCH_PROMO_CODES_SUCCESS = 'FETCH_PROMO_CODES_SUCCESS';
export const FETCH_PROMO_CODES_ERROR = 'FETCH_PROMO_CODES_ERROR';

export default {
  FETCH_PROMO_CODES_START,
  FETCH_PROMO_CODES_SUCCESS,
  FETCH_PROMO_CODES_ERROR,
};
